import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { VenueService } from '../services/venue.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { TypeaheadService } from '../services/typeahead.service';

@Component({
  selector: 'app-venue',
  templateUrl: './venue.component.html',
  styleUrls: ['./venue.component.css']
})
export class VenueComponent implements OnInit {
  @ViewChild('searchInput') searchInput!: ElementRef;

  searchTerm: string = '';
  searchResults: VenueSearchResult[] = [];
  selectedVenue: Venue | null = null;
  recentVenues: Venue[] = [];
  selectedIndex: number = -1;
  showResults: boolean = false;
  isSearching: boolean = false;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {}

  async handleVenueSelect(venue: any){
    this.router.navigate([`/venues/${venue.sid}/details`]);
  }

}
